"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicalOperator = exports.ApplicationType = void 0;
var auth_service_1 = require("./services/auth-service");
var cart_service_1 = require("./services/cart-service");
var catalog_service_1 = require("./services/catalog-service");
var cms_service_1 = require("./services/cms-service");
var commission_service_1 = require("./services/commission-service");
var customer_service_1 = require("./services/customer-service");
var notification_service_1 = require("./services/notification-service");
var order_service_1 = require("./services/order-service");
var payment_service_1 = require("./services/payment-service");
var promotion_service_1 = require("./services/promotion-service");
var setting_service_1 = require("./services/setting-service");
var tax_service_1 = require("./services/tax-service");
var zone_service_1 = require("./services/zone-service");
var client_1 = require("./client");
var index_1 = require("./ws/index");
var futureecom = /** @class */ (function () {
    function futureecom(config) {
        this.config = config;
        this._services = {};
        this.config = config;
    }
    Object.defineProperty(futureecom.prototype, "client", {
        get: function () {
            return (0, client_1.default)(this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "auth", {
        get: function () {
            if (!this._services.auth) {
                this._services.auth = new auth_service_1.default(this);
            }
            return this._services.auth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "catalog", {
        get: function () {
            if (!this._services.catalog) {
                this._services.catalog = new catalog_service_1.default(this);
            }
            return this._services.catalog;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "settings", {
        get: function () {
            if (!this._services.settings) {
                this._services.settings = new setting_service_1.default(this);
            }
            return this._services.settings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "customers", {
        get: function () {
            if (!this._services.customers) {
                this._services.customers = new customer_service_1.default(this);
            }
            return this._services.customers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "taxes", {
        get: function () {
            if (!this._services.taxes) {
                this._services.taxes = new tax_service_1.default(this);
            }
            return this._services.taxes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "zones", {
        get: function () {
            if (!this._services.zones) {
                this._services.zones = new zone_service_1.default(this);
            }
            return this._services.zones;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "carts", {
        get: function () {
            if (!this._services.carts) {
                this._services.carts = new cart_service_1.default(this);
            }
            return this._services.carts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "payments", {
        get: function () {
            if (!this._services.payments) {
                this._services.payments = new payment_service_1.default(this);
            }
            return this._services.payments;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "promotions", {
        get: function () {
            if (!this._services.promotions) {
                this._services.promotions = new promotion_service_1.default(this);
            }
            return this._services.promotions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "orders", {
        get: function () {
            if (!this._services.orders) {
                this._services.orders = new order_service_1.default(this);
            }
            return this._services.orders;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "ws", {
        /**
         * @throws {Error}
         */
        get: function () {
            if (!this.config.ws) {
                throw new Error('WebSocket configuration is undefined.');
            }
            if (!this._ws) {
                this._ws = (0, index_1.default)(this.config);
            }
            return this._ws;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "cms", {
        get: function () {
            if (!this._services.cms) {
                this._services.cms = new cms_service_1.default(this);
            }
            return this._services.cms;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "notifications", {
        get: function () {
            if (!this._services.notifications) {
                this._services.notifications = new notification_service_1.default(this);
            }
            return this._services.notifications;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(futureecom.prototype, "commissions", {
        get: function () {
            if (!this._services.commissions) {
                this._services.commissions = new commission_service_1.default(this);
            }
            return this._services.commissions;
        },
        enumerable: false,
        configurable: true
    });
    futureecom.prototype.usingOrganisation = function (organisation) {
        return this.createNewInstance({
            organisationId: typeof organisation === 'number' ? organisation : organisation.id,
            storeId: undefined,
        });
    };
    futureecom.prototype.usingStore = function (store) {
        return this.createNewInstance({
            organisationId: store.organisation,
            storeId: store.id,
        });
    };
    futureecom.prototype.createNewInstance = function (config) {
        var cloneConfig = function (config) {
            var clone = Object.create(Object.getPrototypeOf(config));
            for (var _i = 0, _a = Object.getOwnPropertyNames(config); _i < _a.length; _i++) {
                var key = _a[_i];
                var desc = Object.getOwnPropertyDescriptor(config, key);
                if (desc) {
                    Object.defineProperty(clone, key, desc);
                }
            }
            return clone;
        };
        var newConfig = cloneConfig(this.config);
        newConfig.organisationId = config.organisationId;
        newConfig.storeId = config.storeId;
        return new futureecom(newConfig);
    };
    return futureecom;
}());
exports.default = futureecom;
var ApplicationType;
(function (ApplicationType) {
    ApplicationType["API"] = "api";
    ApplicationType["CONSOLE"] = "console";
    ApplicationType["OVERVIEW"] = "overview";
    ApplicationType["POS"] = "pos";
    ApplicationType["STOREFRONT"] = "storefront";
})(ApplicationType = exports.ApplicationType || (exports.ApplicationType = {}));
var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["ALL"] = "All";
    LogicalOperator["ANY"] = "Any";
})(LogicalOperator = exports.LogicalOperator || (exports.LogicalOperator = {}));
//# sourceMappingURL=futureecom.js.map